<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import 'assets/js/swiper-bundle.min'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (document.documentElement.clientWidth <= 800) {
      window.location.href = "http://www.hitaledu.com/mobile/";
    }
  },
  mounted() {
    var swiper = new Swiper(".mySwiper", {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {},
    });
    $("#btn1").click(function () {
      alert(mySwiper.activeIndex);
    });
  },
};
</script>
<style lang="less">
// @import url(assets/js/swiper-bundle.min.css);
// 超链接
.ban {
  cursor: pointer;
}
a {
  text-decoration: none;
}
//列表
ul {
  list-style-type: none;
}
// 轮播点
.el-carousel__indicator--horizontal {
  // padding: 40px 4px !important;
}
.el-carousel__indicators--outside button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.el-carousel__arrow{
  width: 50px !important;
  height: 50px !important;
  font-size: 26px !important;
}
.el-carousel__button{
  height: 4px !important;
}
/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */
@screen-sm-min: 414px;

@media (max-width: @screen-sm-min) {
  .card {
    width: 100%;
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
// @media (min-width: @screen-md-min) {

//   }
@screen-lg-min: 414px;
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) {
  // 公共块的样式
  .card {
    width: 1200px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
</style>
